import * as React from 'react'
import { routeProvider } from '$utils/routeProvider'
import { DropdownMenu, DropdownItem } from '$views/components/DropdownMenu'
import { Logout } from '$views/Logout'
import history from '$utils/history'
import { userGroupService } from '$utils/services/userGroupService'
import { useUnreadMessages } from '$utils/hooks/useUnreadMessages'

const onClickServices = () => history.push(routeProvider.myServices)

const onClickStart = () => history.push(routeProvider.myUserArea)

const onClickProfile = () => history.push(routeProvider.profile)

const onClickSettings = () => history.push(routeProvider.settings)

const onClickOffers = () => history.push(routeProvider.offersForCaretaker)

const onClickCustomerSearcher = () => history.push(routeProvider.caretakerList)

const onClickMessages = () => history.push(routeProvider.chat)

const onClickImagesReviews = () => history.push(routeProvider.imagesReviews)

const onClickNursingHomeHelp = () => window.location.assign(routeProvider.nursingHomeHelp)

const isNormalCustomerOrCallCenter = () => userGroupService.isNormalCustomer() || userGroupService.isCallcenter()

const isResidence = () => userGroupService.isResidenceAdmin() || userGroupService.isResidenceModerator()

export const HeaderDropdownMenu: React.SFC = () => (
  <DropdownMenu color="darkGrey">
    {userGroupService.isCustomer() && (
      <>
        {userGroupService.isNormalCustomer() && <DropdownItem onClick={onClickStart}>Inicio</DropdownItem>}
        <DropdownItem onClick={onClickServices}>
          {isNormalCustomerOrCallCenter() ? 'Mis servicios' : 'Mi área privada'}
        </DropdownItem>
        {userGroupService.isNormalCustomer() && (
          <DropdownItem onClick={onClickMessages} circle={useUnreadMessages()}>
            Chat
          </DropdownItem>
        )}
        <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
        {isNormalCustomerOrCallCenter() && <DropdownItem onClick={onClickProfile}>Mi perfil</DropdownItem>}
        {!userGroupService.isCallcenter() && <DropdownItem onClick={onClickSettings}>Ajustes</DropdownItem>}
        {isResidence() && <DropdownItem onClick={onClickNursingHomeHelp}>Ayuda</DropdownItem>}
      </>
    )}
    {userGroupService.isCaretaker() && (
      <>
        <DropdownItem onClick={onClickOffers}>Ofertas</DropdownItem>
        <DropdownItem onClick={onClickServices}>Mis servicios</DropdownItem>
        <DropdownItem onClick={onClickMessages} circle={useUnreadMessages()}>
          Chat
        </DropdownItem>
        <DropdownItem onClick={onClickProfile}>Mi perfil</DropdownItem>
        <DropdownItem onClick={onClickSettings}>Ajustes</DropdownItem>
      </>
    )}
    {userGroupService.isAdmin() && (
      <>
        <DropdownItem onClick={onClickServices}>Mi área privada</DropdownItem>
        <DropdownItem onClick={onClickCustomerSearcher}>Profesionales en tu zona</DropdownItem>
        {(process.env.REACT_APP_AUXILIARES as string) === 'true' && (
          <DropdownItem onClick={onClickImagesReviews}>Revisión imágenes</DropdownItem>
        )}
      </>
    )}
    <Logout />
  </DropdownMenu>
)



// WEBPACK FOOTER //
// ./src/views/components/Layout/FirstLevelHeader/components/HeaderDropdownMenu.tsx